// frontend/src/components/ProductCard.js

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { formatCurrency, IMAGE_BASE_URL } from '../services/utils';
import { useFavorites } from '../context/FavoritesContext';

const favoriteButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  zIndex: 10,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  borderRadius: '50%',
  border: 'none',
  width: '35px',
  height: '35px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  padding: '0'
};

const placeholderImage = 'https://placehold.co/600x400?text=Mercado+Jopoi';

function ProductCard({ item }) {
  const navigate = useNavigate();
  const { favoriteIds, addFavorite, removeFavorite, authChecked } = useFavorites();

  if (!item) {
    return null;
  }

  const isFavorited = favoriteIds.has(item.id);
  const token = sessionStorage.getItem('token');

  const imageUrl = item.imagen_filename
    ? `${IMAGE_BASE_URL}${item.imagen_filename}`
    : placeholderImage;

  const facultadNombre = item.facultad?.nombre || 'General';
  const universidadSiglas = item.facultad?.universidad?.siglas || null;

  const handleToggleFavorite = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!token) {
      navigate('/login', { state: { from: window.location.pathname } });
      return;
    }

    if (isFavorited) {
      await removeFavorite(item.id);
    } else {
      await addFavorite(item);
    }
  };

  return (
    <div className="card h-100 shadow-sm border-0 product-card" style={{ position: 'relative', borderRadius: '12px', overflow: 'hidden' }}>

      {authChecked && token && (
         <button
            onClick={handleToggleFavorite}
            style={favoriteButtonStyle}
            title={isFavorited ? 'Quitar de favoritos' : 'Añadir a favoritos'}
            className="btn-favorite"
         >
            {isFavorited ? (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="red" className="bi bi-heart-fill" viewBox="0 0 16 16">
                <path fillRule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"/>
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-heart" viewBox="0 0 16 16">
                <path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/>
              </svg>
            )}
         </button>
      )}

      <Link to={`/items/${item.id}`} className="text-decoration-none">
        <img
          src={imageUrl}
          alt={item.titulo}
          style={{ width: '100%', aspectRatio: '1/1', objectFit: 'cover', display: 'block' }}
        />
      </Link>
      <div className="card-body d-flex flex-column p-2">
        <h6 className="card-title mb-1" style={{ fontSize: '0.85rem', lineHeight: 1.3, fontWeight: 600 }}>
          <Link to={`/items/${item.id}`} className="text-dark text-decoration-none stretched-link">
            {item.titulo}
          </Link>
        </h6>

        <small className="text-muted mb-1 d-flex align-items-center" style={{ fontSize: '0.72rem' }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-bank me-1" viewBox="0 0 16 16">
            <path d="M8 .95 1.75 4h12.5L8 .95zM1 4.5v.5l.5.25v6.5H1V12h14v-1.25h-1V5.75l.5-.25zM2.5 5.75V11h-1V5.75l.5-.25zM4.5 5.75V11h-1V5.75l.5-.25zM6.5 5.75V11h-1V5.75l.5-.25zM8.5 5.75V11h-1V5.75l.5-.25zM12.5 5.75V11h-1V5.75l.5-.25z"/>
          </svg>
          {facultadNombre} {universidadSiglas ? `(${universidadSiglas})` : ''}
        </small>

        <p className="card-text text-muted mb-1" style={{ fontSize: '0.72rem' }}>{item.estado} | {item.tipo_operacion}</p>

        <p className="card-text text-primary fw-bold mt-auto mb-0" style={{ fontSize: '0.9rem' }}>
          {formatCurrency(item.precio)}
        </p>
      </div>
    </div>
  );
}

export default ProductCard;
